import React, { FunctionComponent, useEffect } from "react";
import { Spinner, Modal, Paragraph } from "@vwfs-bronson/bronson-react";
import { Output } from '../../Text';
import { Analytics } from '../../services/analytics';
import { setActualPage } from '../../pages/page.utils';

type CreditCheckPopupProps = {
  show: boolean;
};

/**
 * Overlay indicating ongoing credit check. Also used for DAC.
 */
export const CreditCheckPopup: FunctionComponent<CreditCheckPopupProps> = ({
  show,
}) => {

  const pageName = 'Credit check progress'

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: 'Credit check progress',
    [Analytics.keys.viewChange()]: 'Credit check progress',
  }

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: 'FinanceApproval',
        [Analytics.keys.eventAction(0)]: 'Request',
      }
      Analytics.setTrackingData({...defaultTrackingData, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  useEffect(() => {
    if (show) {
      setActualPage(pageName)
      trackPage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return (
    <Modal
      id="creditCheckModal"
      center
      hideCloseButton
      title={Output.resolve("pages.leasing.creditCheck.title")}
      shown={show}
    >
      <div>
        <Spinner center className="u-mv"/>
        <Paragraph>
          {Output.resolve("pages.leasing.creditCheck.info")}
        </Paragraph>
      </div>
    </Modal>
  );
};
